import React from "react";
import { IconButton, withStyles } from "@material-ui/core";
import { DeleteOutlined } from "@material-ui/icons";

const styles = (theme) => ({
  iconButtonRoot: {
    color: theme.error,
    float: "right",
    display: "flex",
    padding: "4 6",
  },
});

const Delete = ({ classes, id, onDelete }) => {
  return (
    <IconButton
      classes={{
        root: classes.iconButtonRoot,
      }}
      onClick={() => onDelete(id)}
    >
      <DeleteOutlined />
    </IconButton>
  );
};

export default withStyles(styles)(Delete);
